<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
        <simple-wizard>
          <template slot="header">
            <h3 class="title">
              Create general quote (non Statutory Inspection)
            </h3>
            <br />
          </template>

          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label">
              Select Plant
            </template>
            <div class="md-layout">
              <label class="md-layout-item md-size-10 md-form-label">
                Search Plant
              </label>
              <div class="md-layout-item md-size-75">
                <md-field>
                  <md-input
                    type="search"
                    clearable
                    placeholder="e.g. site name, building name/address or serial no"
                    v-model="searchCriteria.searchText"
                    @keydown.enter.native="getPlantItems()"
                  ></md-input>
                  <md-button
                    class="md-icon-button md-primary"
                    @click="getPlantItems()"
                  >
                    <md-icon>search</md-icon>
                  </md-button>
                </md-field>
              </div>
            </div>
            <br />
            <div class="md-layout" v-show="hasSearched">
              <label class="md-layout-item md-size-10 md-form-label">
                Select Plant
              </label>
              <div class="md-layout-item md-size-65">
                <md-field>
                  <md-select
                    v-model="form.plantId"
                    :disabled="plantOptions.length === 0"
                  >
                    <md-option
                      v-for="plant in plantOptions"
                      :key="plant.id"
                      :value="plant.id"
                    >
                      {{
                        plant.buildingName +
                          ": " +
                          plant.serialNo +
                          " - " +
                          plant.location
                      }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <h5 class="md-layout-item md-size-10">
                Count: {{ plantOptions.length }}
              </h5>
            </div>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              Quote Details
            </template>
            <form class="form-horizontal" action method="post">
              <div class="md-layout" v-show="plantOptions.length !== 0">
                <label class="md-layout-item md-size-10 md-form-label">
                  Value (&#163;)
                </label>
                <div class="md-layout-item md-size-75">
                  <md-field>
                    <md-input v-model="form.value" required></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout" v-show="plantOptions.length !== 0">
                <label class="md-layout-item md-size-10 md-form-label">
                  Description
                </label>
                <div class="md-layout-item md-size-75">
                  <md-field>
                    <md-textarea
                      v-model="form.description"
                      required
                    ></md-textarea>
                  </md-field>
                </div>
              </div>
            </form>
          </wizard-tab>
        </simple-wizard>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { SimpleWizard, WizardTab } from "@/components";
export default {
  components: {
    SimpleWizard,
    WizardTab
  },
  data() {
    return {
      form: {
        plantId: undefined,
        description: "",
        value: 0
      },
      searchCriteria: {
        searchText: undefined
      },
      plantOptions: [],
      hasSearched: false
    };
  },
  methods: {
    clearForm() {
      this.form.plantId = undefined;
      this.form.description = "";
      this.form.value = undefined;
    },
    async getPlantItems() {
      this.$store
        .dispatch("client/searchPlant", {
          searchCriteria: this.searchCriteria
        })
        .then(data => {
          this.plantOptions = data;
          this.clearForm();
          this.hasSearched = true;
        });
    },
    validateStep(ref) {
      if (ref === "step1" && this.form.plantId !== undefined) {
        return true;
      } else if (ref === "step2") {
        this.onSubmit();
      }
      return false;
    },
    onSubmit() {
      this.hasSubmit = true;
      this.form.value = parseFloat(this.form.value);
      this.$store
        .dispatch("quote/createQuote", {
          quote: this.form
        })
        .then(data => {
          this.$router.push({
            name: "Quote",
            params: { quoteId: data }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  },
  watch: {
    "searchCriteria.searchText"() {
      if (this.searchCriteria.searchText === "") {
        this.plantOptions = [];
        this.clearForm();
      }
    }
  }
};
</script>

<style></style>
